import React from 'react';
import { Link } from 'react-router-dom';  // Importa Link para navegación
import '../css/home.css'; // Estilos separados
import ScrollToTopButton from "../components/scrollButton";

function Home() {
  return (
    <div className="trabaja-container">
      <div className="texto-container">
        <h1>ÚNETE A NUESTRO EQUIPO</h1>
        <p>
          ¡Forma parte de nuestra familia y trabaja con nosotros! Como empresa, creemos firmemente en el poder de las personas y en su capacidad para transformar el mundo.
          Si eres una persona apasionada, creativa y comprometida, te invitamos a explorar las oportunidades que tenemos disponibles y a ser parte de nuestro equipo.
          Completa nuestro formulario y nos pondremos en contacto contigo.
        </p>

        <Link to="/ofertas" className="btn btn-sm btn-outline-pink fw-bold">
          Vacantes
        </Link>
      </div>

      <div className="imagen-container">
        <img
          src="/images/avatar.png"
          alt="Equipo de trabajo"
        />
      </div>
      {/* Boton flotante */}
        <ScrollToTopButton />
    </div>
  );
}

export default Home;
